import React, { useContext, useState } from "react";
import { ConfirmDelete, MwButton, MwSelector, MwSpinnerButton } from "../../components/ui";
import LevelContext from "../../utils/UserLevel";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useTenant } from "../../hooks";
import axios from "axios";

export const LevelSettings = ({ title }) => {
  const [t] = useTranslation("global");
  const isRtl = i18next.dir(i18next.language) === "rtl";
  const currentLang = isRtl ? "ar" : "en";
  const levels = [
    { id: 1, label: t("setting.levelOne"), value: 1, lang: currentLang },
    { id: 2, label: t("setting.levelTwo"), value: 2, lang: currentLang },
    { id: 3, label: t("setting.levelThree"), value: 3, lang: currentLang },
    { id: 4, label: t("setting.levelFour"), value: 4, lang: currentLang },
    { id: 5, label: t("setting.levelFive"), value: 5, lang: currentLang },
  ];
  const {
    chart_account_level_limit,
    cost_center_level_limit,
    LevelId,
    GetLevel,
  } = useContext(LevelContext) || {};
  const { tenantId, companySelected } = useTenant();
  const initialState = {
    chart_account_level_limit: null,
    cost_center_level_limit: null,
  };
  const [settingsData, setSettingsData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const BaseUrl = process.env.REACT_APP_INV_API_SERVER_BASE_URL;
  const getLevelOption = (levelValue) =>
    levels.find((item) => Number(item.value) === Number(levelValue)) || null;

  const selectedChartAccountLevel =
    settingsData.chart_account_level_limit ||
    getLevelOption(chart_account_level_limit);

  const selectedCostCenterLevel =
    settingsData.cost_center_level_limit ||
    getLevelOption(cost_center_level_limit);

  const Update = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${BaseUrl}/setting/store`, {
        id: LevelId,
        tenant_id: tenantId,
        company_id: companySelected?.value,
        chart_account_level_limit:
          settingsData.chart_account_level_limit?.value ||
          chart_account_level_limit,
        cost_center_level_limit:
          settingsData.cost_center_level_limit?.value ||
          cost_center_level_limit,
      });
      console.log(res);
      GetLevel();
      setIsConfirmOpen(false);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content col-span-9 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h1 className="text-md font-semibold text-[#261759]">
        {title}
        <div className="options flex justify-normal items-center gap-4">
          <MwSelector
            label={t("setting.chartAccountsLevelLabel")}
            dataType={"labelValue"}
            _data={levels}
            withAddNew={false}
            withSearch={false}
            setSelectedItem={(e) => {
              setSettingsData((prev) => ({
                ...prev,
                chart_account_level_limit: e,
              }));
            }}
            selectedItem={selectedChartAccountLevel}
          />
          <MwSelector
            label={t("setting.costCentersLevelLabel")}
            dataType={"labelValue"}
            _data={levels}
            withAddNew={false}
            withSearch={false}
            setSelectedItem={(e) => {
              setSettingsData((prev) => ({
                ...prev,
                cost_center_level_limit: e,
              }));
            }}
            selectedItem={selectedCostCenterLevel}
          />
          <div className="mt-7">
            <MwButton
              type="primary"
              disabled={loading}
              onClick={() => setIsConfirmOpen(true)}
            >
              {loading ? <MwSpinnerButton /> : t("common.update")}
            </MwButton>
          </div>
        </div>
      </h1>
      <ConfirmDelete
        onShow={isConfirmOpen}
        type="level"
        btnLabel={t("common.update")}
        msg={t("setting.confirmUpdateLevelsMsg")}
        setOnShow={setIsConfirmOpen}
        onDeleteHandler={Update}
        loading={loading}
        onCancelHandle={() => setIsConfirmOpen(false)}
      />
    </div>
  );
};
